import FilterSelect from "@/components/FilterSelect";
import FilterGroup from "@/components/FilterSelect/FilterGroup";
import { COLOR_ITEM_MAP, COLOR_LIST } from "@/constants/color";
import { FILE_TYPE_ITEM_MAP, FILE_TYPE_LIST } from "@/constants/fileType";
import { RESOLUTION_ITEM_MAP, RESOLUTION_LIST } from "@/constants/resolution";
import { SORT_BY_SEARCH_ITEM_MAP, SORT_BY_SEARCH_LIST } from "@/constants/sort";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import PinList from "../../components/PinList";

import { getSearchBoardPins } from "../../services";

import { useRouter } from "next/router";
import styles from "./index.module.less";

export default function SearchBoardPinList({ query, empty }) {
  const pageRef = useRef(1);
  const router = useRouter();
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const { q, boardId, userId, fileType, color, resolution, sort } = query;

  const queryAction = useMemo(() => {
    pageRef.current = 1;
    setDataSource([]);
    setHasMore(true);

    return async () => {
      if (!q || !boardId || !userId) {
        return;
      }

      const per_page = 20;

      const result = await getSearchBoardPins({
        q,
        board_id: boardId,
        user_id: userId,
        per_page,
        page: pageRef.current,
        ...(fileType ? { file_type: fileType } : null),
        ...(color ? { colors: color } : null),
        ...(resolution ? { resolution } : null),
        //等于时间升序或降序
        ...(sort === "asc" || sort === "desc"
          ? { "sort[created_at]": sort }
          : { sort }),
      });

      const pins = result?.pins || [];

      if (pins.length <= 0) {
        setHasMore(false);
      }

      setDataSource((dataSource) => dataSource.concat(pins));
      setTotal(result?.total || 0);
    };
  }, [q, boardId, userId, fileType, color, resolution, sort]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  const onLoadMore = useCallback(() => {
    pageRef.current += 1;
    queryAction();
  }, [queryAction]);

  const onChangeFilter = useCallback(
    (option, field) => {
      router.push({
        page: "/search",
        query: Object.entries({
          q,
          board_id: boardId,
          ...(color ? { color } : null),
          ...(fileType ? { file_type: fileType } : null),
          ...(resolution ? { resolution } : null),
          ...(sort ? { sort } : null),
          [field]: option?.value,
        }).reduce((result, [key, value]) => {
          if (value) {
            result[key] = value;
          }

          return result;
        }, {}),
      });
    },
    [boardId, color, fileType, q, resolution, sort, router]
  );

  return (
    <div className={styles.tab}>
      <div className={styles.info}>
        <div className={styles.text}>
          找到 {total} 个与 <span>{q}</span> 相关的采集
        </div>
        <div className={styles.filter}>
          <FilterGroup>
            <FilterSelect
              className={styles.button}
              name="排序"
              allowClear={false}
              options={SORT_BY_SEARCH_LIST}
              value={SORT_BY_SEARCH_ITEM_MAP[sort]}
              onChange={(option) => onChangeFilter(option, "sort")}
            />
            <FilterSelect
              className={styles.button}
              name="格式"
              options={FILE_TYPE_LIST}
              value={FILE_TYPE_ITEM_MAP[fileType]}
              onChange={(option) => onChangeFilter(option, "file_type")}
            />
            <FilterSelect
              className={styles.button}
              name={"颜色"}
              options={COLOR_LIST}
              iconType="img"
              optionType="img"
              value={COLOR_ITEM_MAP[color]}
              onChange={(option) => onChangeFilter(option, "color")}
            />
            <FilterSelect
              className={styles.button}
              name="尺寸"
              options={RESOLUTION_LIST}
              value={RESOLUTION_ITEM_MAP[resolution]}
              onChange={(option) => onChangeFilter(option, "resolution")}
            />
          </FilterGroup>
        </div>
      </div>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <PinList
            dataSource={dataSource}
            hideUser={true}
            showBoardLink={false}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        </Then>
        <Else>{empty}</Else>
      </If>
    </div>
  );
}
